import logoNoronCar from '../Images/logo.png'

import "./Login.css";
import loginLogo from '../Images/logoWeb.png'
import React, { useContext, useEffect, useState, useRef } from "react";
import config from "../config.json";
import { Link } from 'react-router-dom';
import http from "../Services/httpService";
import service from "../Services/services";
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';

export default function Login() {
    let navigate = useNavigate();
    const [isPosting, setIsPosting] = useState(false);
    const [form, setForm] = useState(
        {
            Username: "", Password: ""
            , Company: config.Company
            , Year: config.Year
            , verision: config.Version
        });
    useEffect(() => {
        const jwt = http.getLocalJwt();
        if (jwt && jwt != "") {
            navigate('/main');
        }
        return () => { }
    }, []);


    const formRef = useRef(null);
    const handlePosting = async (e) => {
        e.preventDefault();
        const forms = formRef.current;
        if (forms.checkValidity() === false) {
            toast.error('داده های ورودی را بررسی بفرمایید', { theme: "colored" });
            forms.classList.add('was-validated')
            return;
        }
        setIsPosting(true);
        await service.RequestVerifyCode(form.mobile, form.codeMeli)
            .then(({ data }) => {
                setIsPosting(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                navigate(`/PrivecyCode`, { state: { mobile: form.mobile, codeMeli: form.codeMeli } });
            })
            .catch(err => {
                setIsPosting(false);
            });
    }

    return (
        <>
            <div className="container vh-100 d-flex align-items-center justify-content-center">
                <div className="w-100">
                    <div className="row mt-2 ">
                        <div className="col d-flex  justify-content-center">
                            <img src={loginLogo} className="img-fluid" alt="logo" />
                        </div>
                    </div>
                    <div className="row mt-3 ">
                        <div className="col fs-4 text-color1 fw-bold d-flex  justify-content-center">
                            ورود به سایت کانون
                        </div>
                    </div>
                    <form
                        ref={formRef}
                        className="needs-validation row mt-3 mx-auto w-100 d-flex justify-content-center"  >
                        <div className="col-md-6">
                            <div className="form-group  mb-3">
                                <input type="text"
                                    className="form-control"
                                    placeholder="شماره موبایل *"
                                    required
                                    value={form.mobile}
                                    onChange={e => http.handleChange(e, form, setForm)}
                                    name="mobile" />
                            </div>

                            <div className="form-group  mb-3">
                                <input type="text"
                                    className="form-control"
                                    placeholder="کد ملی *"
                                    required
                                    value={form.codeMeli}
                                    onChange={e => http.handleChange(e, form, setForm)}
                                    name="codeMeli" />
                            </div>
                            <div className=" d-flex justify-content-center">
                                <button

                                    className="btn w-50 rounded-pill btn-primary "
                                    onClick={handlePosting}
                                    disabled={isPosting}>
                                    ورود
                                    {isPosting &&
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>}
                                </button>
                            </div>
                        </div>
                    </form>
                    <div className="row mt-4 mb-4 ">
                        <div className="col d-flex  justify-content-center">
                            <Link to="/register" ><img src={logoNoronCar} className="img-fluid rounded-circle iconLink mx-2 shadow" alt="logoWeb" />ثبت نام</Link>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );

}
